import { addBlankDay } from '@/middlewares/C3Wrapper/MakeProgressData/AddBlankDay'
import checkDataError from '@/middlewares/C3Wrapper/MakeProgressData/checkDataError'
import getTheDayIndex from '@/middlewares/C3Wrapper/MakeProgressData/getTheDayIndex'

import timeParse from 'date-fns/parse'
import { cloneDeep } from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days'
import differenceInCalendarDays from 'date-fns/difference_in_calendar_days'

const filterTargetBudget = targetBudget => {
  if (targetBudget < 0) {
    return 0
  }

  return targetBudget
}

export class MakeProgressData {
  static makeProgressData({ data, targetBudget, today, bpStart, bpEnd }) {
    const isError = checkDataError({ data, today })
    if (isError) {
      throw Error('date がおかしいです。')
    }

    const filteredTargetBudget = filterTargetBudget(targetBudget)
    const blankFilledData = addBlankDay({
      data,
      start: bpStart,
      end: bpEnd,
    })

    const firstDayToYesterdayFilledData = this.firstDayToYesterday({
      data: blankFilledData,
      today,
      bpEnd,
    })

    const tomorrowToLastDayFilledData = this.tomorrowToLastDay({
      data: firstDayToYesterdayFilledData,
      today,
      bpEnd,
      targetBudget: filteredTargetBudget,
    })

    const calculatedBudget = this.calculatedBudget({
      data: tomorrowToLastDayFilledData,
      targetBudget: filteredTargetBudget,
      today,
      bpEnd,
    })

    return this.theDay({
      data: tomorrowToLastDayFilledData,
      calculatedBudget,
      today,
    })
  }

  static addBudgetData({ data, start, end, budget }) {
    const cloneData = cloneDeep(data)
    const startDayIndex = getTheDayIndex(data, start)
    const endDayIndex = getTheDayIndex(data, end)

    cloneData.forEach((o, index) => {
      if (index >= startDayIndex && index <= endDayIndex) {
        o.targetBudget = budget
      }
    })
    return cloneData
  }

  static firstDayToYesterday({ data, today, bpEnd }) {
    const firstDay = data[0].reportDate
    const yesterdayObject = addDays(timeParse(today), -1)
    const bpEndObject = timeParse(bpEnd)
    const difference = differenceInCalendarDays(bpEndObject, yesterdayObject)
    const bool = difference < 0 // true の場合は、today のほうが bpEnd より足が出てしまっているので、bpEnd を採用する
    const yesterday = format(addDays(timeParse(today), -1), 'YYYY-MM-DD')
    return this.addBudgetData({
      data,
      start: firstDay,
      end: bool ? bpEnd : yesterday,
      budget: 0,
    })
  }

  static tomorrowToLastDay({ data, today, bpEnd, targetBudget }) {
    const tomorrowObject = addDays(timeParse(today), 1)
    const bpEndObject = timeParse(bpEnd)
    const difference = differenceInCalendarDays(bpEndObject, tomorrowObject)
    if (difference < 0) return data // true の場合は、tomorrow のほうが bpEnd より足が出てしまっているので、何もせず終わり
    const tomorrow = format(addDays(timeParse(today), 1), 'YYYY-MM-DD')
    const [lastDayItem] = data.slice(-1)
    const lastDayFormatted = format(
      timeParse(lastDayItem.reportDate),
      'YYYY-MM-DD',
    )
    return this.addBudgetData({
      data,
      start: tomorrow,
      end: lastDayFormatted,
      budget: targetBudget,
    })
  }

  static calculatedBudget({ data, today, bpEnd, targetBudget }) {
    const todayObject = timeParse(today)
    const bpEndObject = timeParse(bpEnd)
    const difference = differenceInCalendarDays(bpEndObject, todayObject)
    if (difference < 0) return 'nothing' // true の場合は、today のほうが bpEnd より足が出てしまっているので、何もせず終わり

    const doneMoney = data[getTheDayIndex(data, today)].revenueBuyingCurrency

    if (doneMoney) {
      const todayTargetBudget = targetBudget - doneMoney
      if (todayTargetBudget < 0) {
        return 0
      }
      return todayTargetBudget
    }

    return targetBudget
  }

  static theDay({ data, today, calculatedBudget }) {
    return this.addBudgetData({
      data,
      start: today,
      end: today,
      budget: calculatedBudget,
    })
  }
}

export const makeProgressData = ({
  data,
  targetBudget,
  today,
  bpStart,
  bpEnd,
}) =>
  MakeProgressData.makeProgressData({
    data,
    targetBudget,
    today,
    bpStart,
    bpEnd,
  })
